import { Entidade, EntidadeServer } from '../model/Entidade'
import { Usuario, UsuarioServer } from '../model/Usuario'
import { Query } from '../model/Query'

function respToEntidade(data: EntidadeServer): Entidade {
    const entidade: Entidade = {
        id: data.id,
        admin: data.admin,
        nome: data.nome,
        areaDeAtuacao: data.area_de_atuacao,
        descricao: data.descricao,
        email: data.email,
        localizacao: data.localizacao,
        site: data.site,
        telefone: data.telefone,
        tipoEntidade: data.tipo_entidade,
        pitch: data.pitch,
        fase: data.fase,
        faturamento: data.faturamento,
        logo: data.logo,
        metas: data.metas,
        publicoAlvo: data.publico_alvo,
        tamanhoEquipe: data.tamanho_equipe
    }
    return entidade
}

function toUsuario(data: UsuarioServer) {
    const usuario: Usuario = {
        email: data.email,
        firstName: data.first_name,
        lastName: data.last_name
    }
    return usuario
}

function toUsuarioServer(usuario: Usuario) {
    const usuarioServer: UsuarioServer = {
        email: usuario.email,
        first_name: usuario.firstName,
        last_name: usuario.lastName,
        password: usuario.password
    }
    return usuarioServer
}

function toEntidades(data: EntidadeServer[]) {
    return data.map((d) => {return respToEntidade(d)})
}

function toEntidadeServer(data: Entidade) {
    const entidadeServer: EntidadeServer = {
        nome: data.nome,
        telefone: data.telefone,
        site: data.site,
        email: data.email,
        descricao: data.descricao,
        area_de_atuacao: data.areaDeAtuacao,
        localizacao: data.localizacao,
        tipo_entidade: data.tipoEntidade,
        admin: data.admin,
        fase: data.fase,
        faturamento: data.faturamento,
        logo: data.logo,
        metas: data.metas,
        pitch: data.pitch,
        publico_alvo: data.publicoAlvo,
        tamanho_equipe: data.tamanhoEquipe
    }

    if (data.admin) entidadeServer.admin = data.admin

    return entidadeServer
}

function createQueryString(query: Query) {
    const {
        page, limit, search, area, city, type, admin
    } = query
    const offset = (page - 1) * limit
    let params
    params = `limit=${limit}&offset=${offset}`
    if (search) params += `&nome=${encodeURIComponent(search)}`
    if (area) params += `&area_de_atuacao=${area}`
    if (city) params += `&cidade=${city}`
    if (type) params += `&tipo=${type}`
    if (admin) params += `&admin=${admin}`
    return params
}

export {
    toEntidades,
    toUsuario,
    toUsuarioServer,
    toEntidadeServer,
    createQueryString,
    respToEntidade
}
